import React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Skeleton from '@mui/material/Skeleton';

const FeedsCardLoading = () => (
  <Card>
    <CardHeader
      avatar={(
        <Skeleton variant="circular" width={40} height={40} />
      )}
      title="Feed"
    />
    <CardContent>
      <List
        aria-label="horse feed"
      >
        <ListItemButton
          disabled
        >
          <ListItemIcon><Skeleton variant="circular" width={40} height={40} /></ListItemIcon>
          <ListItemText
            primary={<Skeleton height={40} width={80} />}
            secondary={(
              <Skeleton height={20} width={200} />
            )}
          />
        </ListItemButton>
        <ListItemButton
          disabled
        >
          <ListItemIcon><Skeleton variant="circular" width={40} height={40} /></ListItemIcon>
          <ListItemText
            primary={<Skeleton height={40} width={80} />}
            secondary={(
              <Skeleton height={20} width={200} />
            )}
          />
        </ListItemButton>
        <ListItemButton
          disabled
        >
          <ListItemIcon><Skeleton variant="circular" width={40} height={40} /></ListItemIcon>
          <ListItemText
            primary={<Skeleton height={40} width={80} />}
            secondary={(
              <Skeleton height={20} width={200} />
            )}
          />
        </ListItemButton>
      </List>
    </CardContent>
  </Card>
);

FeedsCardLoading.propTypes = { };

export default FeedsCardLoading;
